// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "escalada-ecom-eb685.firebaseapp.com",
  "projectId": "escalada-ecom-eb685",
  "storageBucket": "escalada-ecom-eb685.appspot.com",
  "messagingSenderId": "547474171291",
  "appId": "1:547474171291:web:9128e0a82fe0754e37ad3e",
  "measurementId": "G-NSC5BBL3KZ",
  "apiKey": "AIzaSyBS9BzqhglxJxc8S0Wlz3OTM-G5CO4CZv0"
};
